module.exports = __webpack_public_path__ + "static/media/agentur_reference_logos_01_mobile.8c15fec4.png";